import moment from 'moment';
import { React, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { Form } from 'react-final-form';
import { Button, Grid, Popover } from '@mui/material';
import { LoadingButton } from '@mui/lab';
import { validateMinLength } from 'common/forms/formValidations';
import DateField from 'common/forms/DateField';
import TextField from 'common/forms/TextField';
import PracticeProfileFieldKeys from 'enums/practice.enum';
import { updatePracticeProfileFilter } from 'store/thunks/practiceThunks';

const PracticeFilterButton = () => {
  const dispatch = useDispatch();
  const [anchorEl, setAnchorEl] = useState(null);

  const { filter } = useSelector(({ practice }) => practice.practiceManagement);

  const handleOpen = (event) => setAnchorEl(event.currentTarget);
  const handleClose = () => setAnchorEl(null);

  const popoverId = anchorEl ? 'PracticeFilterButton-Popover' : undefined;
  const loading = useSelector(({ practice }) => practice.practiceManagement.loading);

  const handleApplyFilter = (formData) => {
    setAnchorEl(null);
    dispatch(
      updatePracticeProfileFilter({
        filter: {
          ...formData,
          createdAt: formData?.createdAt && moment(formData.createdAt).format('YYYY-MM-DD'),
          updatedAt: formData?.updatedAt && moment(formData.updatedAt).format('YYYY-MM-DD'),
        },
      })
    );
  };
  return (
    <>
      <Button
        sx={{ height: 33 }}
        variant='outlined'
        color='secondary'
        onClick={handleOpen}
        aria-describedby={popoverId}
      >
        Filters
      </Button>
      <Popover
        id={popoverId}
        open={!!anchorEl}
        anchorEl={anchorEl}
        onClose={handleClose}
        anchorOrigin={{ vertical: 'bottom', horizontal: 'right' }}
        transformOrigin={{ vertical: 'top', horizontal: 'right' }}
      >
        <Grid container sx={{ p: 1.5, width: 325 }} spacing={2} direction='column'>
          <Grid item>
            <Form
              initialValues={{
                ...filter,
                [PracticeProfileFieldKeys.CREATED_AT]: filter[PracticeProfileFieldKeys.CREATED_AT]
                  ? moment(filter[PracticeProfileFieldKeys.CREATED_AT], 'YYYY-MM-DD').toDate()
                  : null,
                [PracticeProfileFieldKeys.UPDATED_AT]: filter[PracticeProfileFieldKeys.UPDATED_AT]
                  ? moment(filter[PracticeProfileFieldKeys.UPDATED_AT], 'YYYY-MM-DD').toDate()
                  : null,
              }}
              onSubmit={handleApplyFilter}
              render={({ handleSubmit, invalid }) => (
                <form onSubmit={handleSubmit} noValidate>
                  <Grid item sx={{ py: 0.5 }}>
                    <TextField
                      label='Practice Name'
                      name={PracticeProfileFieldKeys.PRACTICE_NAME}
                      id='PracticeFilterButton-practiceName-input'
                      validations={[validateMinLength('Minimum of 3 characters', 3)]}
                    />
                  </Grid>

                  <Grid item sx={{ py: 0.5 }}>
                    <TextField
                      label='Partner Name'
                      name={PracticeProfileFieldKeys.PARTNER_NAME}
                      id='PracticeFilterButton-partnerName-input'
                      validations={[validateMinLength('Minimum of 3 characters', 3)]}
                    />
                  </Grid>
                  <Grid item sx={{ py: 0.5 }}>
                    <DateField
                      label='Created At'
                      name={PracticeProfileFieldKeys.CREATED_AT}
                      id='PracticeFilterButton-createdAt-input'
                      maxDate={new Date()}
                    />
                  </Grid>

                  <Grid item sx={{ py: 0.5 }}>
                    <DateField
                      label='Updated At'
                      name={PracticeProfileFieldKeys.UPDATED_AT}
                      id='PracticeFilterButton-updatedAt-input'
                      maxDate={new Date()}
                    />
                  </Grid>

                  <Grid container justifyContent='flex-end'>
                    <LoadingButton
                      loading={loading}
                      type='submit'
                      variant='contained'
                      disabled={invalid}
                    >
                      Apply
                    </LoadingButton>
                  </Grid>
                </form>
              )}
            />
          </Grid>
        </Grid>
      </Popover>
    </>
  );
};

export default PracticeFilterButton;
